import { ComponentLoader } from '@bythepixel/component-loader';
import AddToCart from './components/addToCart';
import CartView from './components/cartView';
import ChangeQuantity from './components/changeQuantity';
import ProductView from './components/productView';

window.shop = new ComponentLoader(document, [AddToCart, CartView, ChangeQuantity, ProductView]);
